module.exports = __webpack_public_path__ + "static/media/multi-image-4.968e342f.png";